import { getField, updateField } from "vuex-map-fields";

const getDefaultState = () => {
  return {
    RBF0406F40: {
      list: [],
    },
  };
};

const termiUpdatRsultHist = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {},
};

export default termiUpdatRsultHist;
